import { IMG } from "@/lib/site";

export const CITIES = [
    {
        name: "Bhuj",
        slug: "bhuj",
        state: "Gujarat · Kutch",
        image: IMG.city_bhuj,
        tagline: "Kutch's historic capital, building its next skyline.",
        nearby: ["ahmedabad"],
        localities: ["Mundra Road", "Mirzapar Road", "Kukma", "Madhapar", "Ganga Nagar"],
    },
    {
        name: "Mumbai",
        slug: "mumbai",
        state: "Maharashtra",
        image: IMG.city_mumbai,
        tagline: "Sea-linked skylines and India's most coveted addresses.",
        nearby: ["pune", "ahmedabad"],
        localities: ["Worli", "Bandra West", "Juhu", "Powai", "Lower Parel", "Andheri West"],
    },
    {
        name: "Bengaluru",
        slug: "bengaluru",
        state: "Karnataka",
        image: IMG.city_bengaluru,
        tagline: "Garden-city living beside India's technology corridor.",
        nearby: ["chennai", "hyderabad"],
        localities: ["Whitefield", "Indiranagar", "Koramangala", "Hebbal", "HSR Layout"],
    },
    {
        name: "Delhi NCR",
        slug: "delhi-ncr",
        state: "National Capital Region",
        image: IMG.city_delhi_ncr,
        tagline: "Grand avenues, golf-course roads and new urban centres.",
        nearby: ["ahmedabad", "mumbai"],
        localities: ["Golf Course Road", "Saket", "Noida Expressway", "Dwarka", "Gurugram"],
    },
    {
        name: "Hyderabad",
        slug: "hyderabad",
        state: "Telangana",
        image: IMG.city_hyderabad,
        tagline: "Old-city charm meeting new-age financial districts.",
        nearby: ["bengaluru", "pune"],
        localities: ["Gachibowli", "Jubilee Hills", "Banjara Hills", "HITEC City", "Kondapur"],
    },
    {
        name: "Pune",
        slug: "pune",
        state: "Maharashtra",
        image: IMG.city_pune,
        tagline: "Cultural capital turned sought-after residential hub.",
        nearby: ["mumbai", "ahmedabad"],
        localities: ["Baner", "Koregaon Park", "Hinjewadi", "Kharadi", "Wakad"],
    },
    {
        name: "Ahmedabad",
        slug: "ahmedabad",
        state: "Gujarat",
        image: IMG.city_ahmedabad,
        tagline: "Riverfront regeneration and ambitious new corridors.",
        nearby: ["bhuj", "mumbai"],
        localities: ["SG Highway", "Bodakdev", "Prahlad Nagar", "Satellite", "GIFT City"],
    },
    {
        name: "Chennai",
        slug: "chennai",
        state: "Tamil Nadu",
        image: IMG.city_chennai,
        tagline: "Coastal boulevards and quietly luxurious neighbourhoods.",
        nearby: ["bengaluru", "hyderabad"],
        localities: ["OMR", "Adyar", "Anna Nagar", "Velachery", "ECR"],
    },
    {
        name: "Kolkata",
        slug: "kolkata",
        state: "West Bengal",
        image: IMG.city_kolkata,
        tagline: "Heritage streetscapes alongside landmark new towers.",
        nearby: ["delhi-ncr", "hyderabad"],
        localities: ["New Town", "Salt Lake", "Ballygunge", "Rajarhat", "Alipore"],
    },
];

export const getCity = (slug) => CITIES.find((c) => c.slug === slug) || null;
